module.exports = __webpack_public_path__ + "static/img/topNavBlack.eabe3f00.png";